<template>
    <div class="entrance-page">
        <router-view />
    </div>
</template>
<script>
export default {}

</script>